import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ap-page-toolbar',
    templateUrl: './page-toolbar.component.html',
    styleUrls: ['./page-toolbar.component.css'],
    standalone: false
})
export class PageToolbarComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
